import request from '@/router/axios'

const normalizePageParams = (params = {}) => {
  const data = { ...params }
  if (data.page != null && data.current == null) {
    data.current = data.page
    delete data.page
  }
  return data
}

export const getList = (params) => {
  return request({
    url: '/api/produce/safety-culture/select/page',
    method: 'post',
    data: normalizePageParams(params),
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/produce/safety-culture/select/id',
    method: 'get',
    params: { id },
  })
}

export const add = (row) => {
  return request({
    url: '/api/produce/safety-culture/insert',
    method: 'post',
    data: row,
  })
}

export const update = (row) => {
  return request({
    url: '/api/produce/safety-culture/update',
    method: 'post',
    data: row,
  })
}

export const complete = (row) => {
  return request({
    url: '/api/produce/safety-culture/complete',
    method: 'post',
    data: row,
  })
}

export const remove = (id) => {
  return request({
    url: '/api/produce/safety-culture/delete/id',
    method: 'get',
    params: { id },
  })
}

export const downloadImportTemplate = () => {
  return request({
    url: '/api/produce/safety-culture/import-template',
    method: 'get',
    responseType: 'blob',
  })
}

export const importExcel = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/produce/safety-culture/import-excel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const exportExcel = (params) => {
  return request({
    url: '/api/produce/safety-culture/export/excel',
    method: 'post',
    data: normalizePageParams(params),
    responseType: 'blob',
  })
}

export const getDeptTree = () => {
  return request({
    url: '/api/produce/blade-dept/select/deptSelect',
    method: 'get',
  })
}

export const uploadEndpoint = '/api/blade-resource/oss/endpoint/put-file-attach'
